import { render, staticRenderFns } from "./transfer-promotion.vue?vue&type=template&id=79faa19e&scoped=true&"
import script from "./transfer-promotion.vue?vue&type=script&lang=js&"
export * from "./transfer-promotion.vue?vue&type=script&lang=js&"
import style0 from "./transfer-promotion.vue?vue&type=style&index=0&id=79faa19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79faa19e",
  null
  
)

export default component.exports